<template>
  <v-container>
    <v-card>
      <v-card-title>
        Live Tracking
        <v-icon right>mdi-map-clock-outline</v-icon>
      </v-card-title>
      <v-card-subtitle>
        <p>
          A requirement for flying in Danger Areas is electronic visibility. An
          actual system for live tracking is:
          <!-- <a href="https://www.safesky.app/" target="_blank">SafeSky. </a> -->
          <v-btn
            href="https://www.safesky.app/"
            target="_blank"
            color="primary"
            small
            >SafeSky
            <v-img :src="SafeSkyLogo" height="24px" width="24px"></v-img
          ></v-btn>
          <!-- </p>
        <p> -->

          SafeSky is first of all useful for traffic awareness.
        </p>

        <p>
          However, SafeSky is not a perfect view for the coordinator (the Box
          opener) or a competition administrator. A far better tool in this
          context is
          <v-btn
            href="https://puretrack.io/"
            target="_blank"
            color="primary"
            small
            >PureTrack
            <v-img :src="PureTrackLogo" height="24px" width="24px"></v-img
          ></v-btn>
          <!-- <a href="https://puretrack.io/" target="_blank">PureTrack</a> -->
        </p>
        <p>
          In PGBox there are <v-chip small>invitation links</v-chip> to
          PureTrack groups. You can find it at Menu: Boxes. Select the "circle"
          drop-down at the individual box.
        </p>
        <v-img
          :src="LiveTrackingHelp1"
          height="200px"
          aspect-ratio="1"
          contain
        ></v-img>
        <p>
          There are also links to a diversity of live tracking systems/maps
          found at the "LIVE TRACKING" drop down.
          <kbd>See more info in the end of this help item.</kbd>
        </p>
        <p>
          Several box areas may link to the same PureTrack group. Other box
          areas may not have an allocated group (yet).
        </p>
        <p>
          The puretrack groups are normally permanent with no expiration date.
          For single events, like gatherings or competitons, the group most
          likely will be valid just for the duration of the event.
        </p>
        <h4>
          As a PGBox user - please make your self visible in PureTrack. Sooner
          or later it probably will be a requirement for flying in some Box
          areas (Danger areas)!
        </h4>
        <br />
        <h4>How to be visible in PureTrack:</h4>

        <ul>
          <li>
            Create a (free) account
            <a href="https://puretrack.io/register" target="_blank">
              Register in PureTrack</a
            >
          </li>
          <!-- <li>
            Use your real name when you register. This will be your default map
            label later.
          </li> -->

          <li>After registration and/or log in:</li>
          <li>
            <dl>
              <dt>
                Create a Map Marker. Select "Paraglider" (or "Hangglider").
              </dt>
              <dd>
                - Use your firstname + firstletter of surname as Map Label!
              </dd>

              <dd>
                <b><i>Example: Ola N</i></b>
              </dd>
              <dt>
                You may edit your map marker later. And even create multiple map
                markers for different purposes.
              </dt>
            </dl>
          </li>
          <v-img :src="PureTrackSettings" max-width="400px"></v-img>
          <p>Example. PureTrack map marker settings.</p>

          <li>Add at least one data source from the "Dashboard".</li>
          <dl>
            <dt>
              For most devices it is a short process with easy to follow help
              page for each source.
            </dt>
            <dt>Among the most relevant sources are:</dt>
            <dd>- XContest (For XCTrack and FlySkyHy users).</dd>

            <dd>- Instruments: Oudie N, Syride, Flymaster ..</dd>
            <dd>
              - Apps: SeeYou Navigator, XCSoar, Wingman, Gaggle,
              <kbd>Traccar Client</kbd>,...
            </dd>
            <dd>
              - If you have for instance an InReach, Spot or FLARM unit - add
              those as a second data source.
            </dd>
          </dl>

          <li>
            <strong>Now - Join the PureTrack group - :)</strong>
          </li>
          <li>
            Remember to enable live-tracking in your instrument/app as well.
          </li>
        </ul>
        <br />
        <hr />
        <kbd>Traccar Client</kbd>
        <br />
        Traccar Client is available for both IOS and Android.
        <p>
          This is a very good option for those who do not have a compatible
          instrument or app. It is also a good option for those who just want to
          be visible in PureTrack without the need for all the features of an
          advanced instrument/app.
        </p>
        <p>
          It is "light-weight" so it does not drain your battery a lot. However,
          it is always a good idea to bring a powerbank.
        </p>
        <p>
          Traccar Client can also run "in the background", whithout having it
          visible on the screen.<i>But remember to close it after use.</i>
        </p>
        <div class="subheading">Traccar settings</div>
        <v-img
          :src="TraccarSettings"
          max-height="400px"
          max-width="400px"
        ></v-img>
        <p>
          Update Traccar settings with the Device Identifier and Server URL from
          Step 2 in the PureTrack configuration.
        </p>
        <br />
        <hr />
        <br />
        <p>
          <kbd>View tasks in PureTrack</kbd> <br />A cool feature in PureTrack
          is scanning QR-code of a task. Used in competition for instance.
        </p>
        <div class="subheading">Example QR Code</div>
        <v-img :src="QR1" max-height="400px" max-width="400px"></v-img>

        <div class="subheading">The corresponding task in PureTrack</div>
        <v-img :src="TaskFromQR1" max-height="400px" max-width="400px"></v-img>

        <!-- <p><v-icon right>mdi-phone-rotate-landscape</v-icon></p> -->
      </v-card-subtitle>
    </v-card>
  </v-container>
</template>


<script>
export default {
  data() {
    return {
      LiveTrackingHelp1: require("@/assets/LiveTrackingHelp1.png"),
      SafeSkyLogo: require("@/assets/safesky-logo.png"),
      PureTrackLogo: require("@/assets/puretrack-logo.png"),
      QR1: require("@/assets/Hvit NC 2023 Dag 3 Gr-Kbr-Skrim-Gr.png"),
      TaskFromQR1: require("@/assets/TaskFromQR1.png"),
      TraccarSettings: require("@/assets/Traccar_settings.png"),
      PureTrackSettings: require("@/assets/PureTrack_settings.png"),
    };
  },
};
</script>